import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-section-polls",
  "use": "foquz-icon-section-polls-usage",
  "viewBox": "0 0 23 21",
  "content": "<symbol viewBox=\"0 0 23 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-section-polls\"><path d=\"M11 3h10.839M11 11.003h10.839M11 18.99h10.839M1 18.499l1.67 1.47L6.032 17M5 3a2 2 0 11-4 0 2 2 0 014 0zm0 8a2 2 0 11-4 0 2 2 0 014 0z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol